import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Button } from 'react-bootstrap';
import TextareaAutosize from 'react-autosize-textarea';
import { getLeadByID, setFirstMessage, setNewDataLead } from '../../redux/reduxActions/leadActions';
import { showToastError } from '../utils';


const SetFirstMessage = (props) => {
  const [message, setMessage] = useState('');
  const [messageID, setMessageID] = useState(undefined);
  const { selectedLead: { first_message, id }, funnelStatuses } = props;
  useEffect(() => {
    props.getLeadByID(props.match.params.id);
  }, []);
  useEffect(() => {
	  if (first_message) {
		  setMessageID(first_message.id);
      setMessage(first_message.text);
	  } else {
		  setMessage('');
	  }
  }, [props]);
  
  function setFirstMessageData() {
	  if (!message) {
		  showToastError('First message field is required!!!');
  		return;
	  }
    props.setFirstMessage({
	    id: messageID || 256,
	    lead_id: id,
	    text: message,
    });
    props.setNewDataLead(id, { funnel_status: funnelStatuses.find((item) => item.name === 'FirstMesageSent').id}, props.history.push, false);
  }
  return (
    <div>
      <div>
        <div className="lead__container" style={{ minHeight: 'auto' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 10 }}>
            <h3 style={{ color: '#383838', marginBottom: 0, height: 'min-content' }}>
	            Set Lead First Message
            </h3>
            <Button
              onClick={() => { setFirstMessageData(); }}
              variant="primary"
              className="main-button-filled"
            >
			        Save
            </Button>
          </div>
          <TextareaAutosize
            onChange={({ target: { value } }) => {
	            setMessage(value);
            }}
            className="lead_input__first-message"
            rows={3}
            placeholder="..."
            value={message}
          />
        </div>
      </div>
    </div>
  );
};
export default connect((store) => ({
  selectedLead: store.leadReducer.selectedLead,
  funnelStatuses: store.leadReducer.funnelStatuses,
}), { getLeadByID, setFirstMessage, setNewDataLead })(SetFirstMessage);
